module.exports = __webpack_public_path__ + "img/new-logo-lion-parcel-black.71555726.png";